import { useState, useEffect } from "react"
import Image from "next/legacy/image"
import Link from "next/link"
import Blocks from "@/components/Blocks"
import { useMediaPredicate } from "react-media-hook"
import { usePropsObject } from "@/lib/contexts/appContext"
import HeadingLabel from "@/common/partials/headingLabel/headingLabel"
import Block from "@/components/wrappers/block"
import { Information } from "./event-info"
import styles from "./calendar-single.module.css"
import classNames from "classnames"

export default function EventContent({ block, settings }) {
  const { heading, image, type, content, doubleInfo, blocks } = block.attrs
  const object = usePropsObject()

  const isMobile = useMediaPredicate("(max-width: 420px)")
  const [hasMounted, setMounted] = useState(false)

  // This is used due to isMobile not working before mount
  useEffect(() => {
    !hasMounted && setMounted(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <Block width="bleed" gap="small" block={block} className="content-wrapper">
      <figure
        className={classNames({
          "hero-image": true,
          "has-caption": image?.credit
        })}>
        {image && (
          <Image
            src={image.url}
            sizes={image.sizes}
            layout="fill"
            objectFit="cover"
          />
        )}
        {image?.credit && (
          <figcaption>
            {image.type}: {image.credit}
          </figcaption>
        )}
      </figure>
      <AvailableSeats settings={settings} />
      {type.name && (
        <HeadingLabel className="type">
          {type.url && (
            <Link href={type.url} prefetch={false}>
              {type.name}
            </Link>
          )}
          {!type.url && <span>{type.name}</span>}
        </HeadingLabel>
      )}
      <h1>{heading}</h1>
      {hasMounted && isMobile && doubleInfo && (
        <div className={classNames(styles.info, "information")}>
          <Information object={object} renderButton={false} />
        </div>
      )}
      {content && (
        <div className="body" dangerouslySetInnerHTML={{ __html: content }} />
      )}
      <Blocks
        blocks={blocks}
        settings={{
          "core/heading": { width: "bleed" },
          "core/paragraph": { width: "bleed" },
          "core/list": { width: "bleed" },
          "theme/accordion-v2": { width: "bleed", item: { isEvent: true } },
          "theme/image": { width: "bleed", gap: "content", isEvent: true }
        }}
      />
    </Block>
  )
}

const AvailableSeats = ({ settings }) => {
  if (!settings.loading && (!settings.active || settings.max === 0)) {
    return null
  }

  const text = settings.loading
    ? "Laddar"
    : settings.available + " Lediga platser"

  return (
    <div
      className={classNames("available-seats", {
        "is-loading": settings.loading
      })}>
      <span className="dot"></span>
      {text}
    </div>
  )
}
